/**
 * TanStack Query hooks for `public-usage-calculator`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publicUsageCalculatorQueryKeys,
	type CreatePublicUsageCalculatorBody,
	type ListPublicUsageCalculatorResponse,
	type PublicUsageCalculatorRow,
} from "./api";

export function usePublicUsageCalculatorList(): UseQueryResult<ListPublicUsageCalculatorResponse, Error> {
	return useQuery({
		queryKey: publicUsageCalculatorQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublicUsageCalculatorCreate(): UseMutationResult<PublicUsageCalculatorRow, Error, CreatePublicUsageCalculatorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publicUsageCalculatorQueryKeys.all });
		},
	});
}

export function usePublicUsageCalculatorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publicUsageCalculatorQueryKeys.all });
		},
	});
}
